export default __webpack_public_path__ + "static/media/how it works  Icon 3.b2f73bba.svg";